/*
 * Copyright (c) Hilo 2020.
 * Author: fharold
 *
 * hilo-oauth-manager
 * LoginPage.tsx
 */

import React from 'react';
import Config from "../../config";
import HiloReactComponent from "../../tools/view/layout/HiloReactComponent";
import Spinner from "../../tools/view/element/Spinner";
import crypto from "js-sha512";
import AuthenticationService from "../../tools/service/AuthenticationService";
import UIError from "../../tools/view/toast/UIError";
import HTTPService from "../../tools/service/HTTPService";

interface State {
    loading: boolean;
}

export default class LoginPage extends HiloReactComponent<{}, State> {
    public static ROUTE = "/login";

    private readonly _authenticationService: AuthenticationService;
    private readonly _httpService: HTTPService;
    private _code: string | null;
    private _codeVerifier: string;
    private _codeChallenge: string;

    constructor(props: {}, state: State) {
        super(props, state);

        this._authenticationService = this._serviceRepository.resolve(AuthenticationService.id) as AuthenticationService;
        this._httpService = this._serviceRepository.resolve(HTTPService.id) as HTTPService;

        this._code = LoginPage._getCode();

        let codeVerifier = this._authenticationService.codeVerifier
        if (!codeVerifier) {
            this._codeVerifier = Math.random().toString(36).substr(2, 16);
            this._authenticationService.saveCodeVerifier(this._codeVerifier);
        } else {
            this._codeVerifier = codeVerifier;
        }

        this._codeChallenge = btoa(crypto.sha512(this._codeVerifier));

        this.state = {loading: false};
    }


    /**
     * componentDidMount
     */
    public componentDidMount() {
        super.componentDidMount();

        this._authUserIfNecessary();
    }

    /**
     * _authUserIfNecessary
     * @private
     */
    private async _authUserIfNecessary() {
        try {
            if (!!this._code) {
                await this._authenticationService.login(this._httpService, this._code, this._codeVerifier)
                return;
            }
        } catch (e) {
            UIError.default.show(e.statusCode);
        }
    }

    /**
     * _getCode
     * @returns {string | null}
     * @private
     */
    private static _getCode(): string | null {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        return params.get('code');
    }

    /**
     * _openOAuth
     * @private
     */
    private _openOAuth = () => {
        const codeChallenge = encodeURI(this._codeChallenge);

        window.location.href = `${Config.OAUTH_API_URL}/oauth/authorize?client_id=${Config.API_CLIENT_ID}` +
            `&redirect_uri=${Config.OAUTH_REDIRECT_URI}` +
            `&response_type=code` +
            `&code_challenge=${codeChallenge}`;
    }

    /**
     * render
     * @return {JSX.Element}
     */
    public render(): JSX.Element {
        const {loading} = this.state;

        return <div className="login-page">
            <div className={"login-button"} onClick={() => this._openOAuth()}>
                {/* {!loading && <img className={"hilo-logo"} src={"/img/hilo-logo.png"} alt={"hilo-logo"}/>} */}
                {!loading && <p>Connexion</p>}
                {loading && <Spinner/>}
            </div>
        </div>;
    }
}